<app-modal-wrapper (cancel)="onCancel()" [options]="options">

  <div class="whiteboard-view-container">
      <iframe [src]="whiteboardUrl | safeurl" style="right: 0; width: 100%; height: 100%; border: none;" title="The embedded miro board"></iframe>
  </div>
</app-modal-wrapper>
